import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const ResetIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 15 15" },
        React.createElement("path", { d: "M14.8198 6.3923C14.507 4.99655 13.7276 3.72311 12.6491 2.78341C9.81651 0.314914 6.0518 0.571503 3.58079 2.58078L1.44126 0.441383C1.1417 0.141583 0.70597 0.219943 0.68027 0.578103L0.24693 6.61105C0.22398 6.93112 0.55119 7.25827 0.87114 7.23532L6.9041 6.80197C7.26219 6.77634 7.3405 6.34054 7.04094 6.04098L5.00487 4.00485C6.07024 3.20114 7.4088 2.84909 8.80339 3.06125C10.7796 3.36179 12.4294 4.89353 12.8694 6.84323C13.5671 9.93503 11.377 12.7043 8.4724 12.9778C8.20867 13.0027 7.99999 13.2068 7.99999 13.4717V14.4775C7.99999 14.7622 8.23888 15.0017 8.52282 14.9807C12.6541 14.674 15.7996 10.7646 14.8198 6.3923Z" })));
};

export { ResetIcon };
//# sourceMappingURL=ResetIcon.esm.js.map
